module.exports = __webpack_public_path__ + "static/media/README.681ca814.md";